import Slider from '../slider/Slider';

export function init(element: HTMLElement) {
  console.log('product-awards-slider.init()');

  element.classList.add('swiper-wrapper-initialized');

  new Slider(element, {
    navigation: true,
    pagination: false,
    swiperOptions: {
      navigation: {
        nextEl: '.slider-container-next',
        prevEl: '.slider-container-prev',
      },
      slidesPerView: 1,
      breakpoints: {
        672: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 32,
        },
        1056: {
          spaceBetween: 32,
          slidesPerGroup: 3,
          slidesPerView: 3,
        },
        1312: {
          spaceBetween: 32,
          slidesPerGroup: 3,
          slidesPerView: 3,
        },
        1584: {
          spaceBetween: 64,
          slidesPerGroup: 4,
          slidesPerView: 4,
        }
      },
    }
  });
}

export default init;
